export default "__VITE_ASSET__CgOtsrLX__"